// extracted by mini-css-extract-plugin
export default {"podcasts__title":"Podcasts_podcasts__title__o2z4K"};